import get from 'lodash/get';
import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState,
} from '../../utils/redux';

import * as updateAssignment from '../dependentManagement/assignment-update-req';
import * as manageAppointments from '../healthboard/requests/manage-pending-request';

export const consts = createReqConsts('data', 'app-state', [
  'CHANGE_TEST_CALL_PERFORMED_STATUS',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'app_state',
  type: 'get',
});

const defaultRequestReducer = createReqReducer(consts);

export default (state = initialState, action) => {
  switch (action.type) {
    case manageAppointments.consts.SUCCEED:
    case updateAssignment.consts.SUCCEED: {
      const assignmentsCount =
        get(state, 'providerPendingEventsFeedItems.totalFeedsCount', 0) - 1;

      return {
        ...state,
        providerPendingEventsFeedItems: {
          ...state.providerPendingEventsFeedItems,
          totalFeedsCount: assignmentsCount > 0 ? assignmentsCount : 0,
        },
      };
    }
    case consts.CHANGE_TEST_CALL_PERFORMED_STATUS: {
      return {
        ...state,
        virtualVisitNetworkTestPerformed: true,
      };
    }

    default: {
      return defaultRequestReducer(state, action);
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/data/app-state-req.js